import type {CardProps} from "@heroui/card";
import type {ComponentProps, ElementType} from "react";

import {Card as HeroUiCard} from "@heroui/card";
import clsx from "clsx";

export const Card = ({children, ...props}: CardProps) => {
  return (
    <HeroUiCard radius="md" shadow="sm" {...props}>
      {children}
    </HeroUiCard>
  );
};

export const CardGrid = ({children, className}: ComponentProps<"div">) => {
  return <div className={clsx("grid gap-6", className)}>{children}</div>;
};

export const CardTitle = ({children, className}: ComponentProps<"h3">) => {
  return <h3 className={clsx("text-body-2-strong text-foreground-500", className)}>{children}</h3>;
};

export const CardDescription = ({children, className}: ComponentProps<"p">) => {
  return <p className={clsx("text-caption-1 text-foreground-500", className)}>{children}</p>;
};

export const CardStat = ({children, className}: ComponentProps<"p">) => {
  return <p className={clsx("text-title-1 text-secondary", className)}>{children}</p>;
};

interface CardIconProps extends ComponentProps<"svg"> {
  icon: ElementType;
  className?: string;
}

export const CardIcon = ({icon: Icon, className, ...rest}: CardIconProps) => {
  return <Icon className={clsx("size-10", className)} {...rest} />;
};
